import React from 'react';
import Modal from './ui/Modal';
import Icon from './ui/Icon';
import useInstalarPWA from '../hooks/useInstalarPWA';

const PLAY_STORE_URL =
  'https://play.google.com/store/apps/details?id=br.com.agrigest.android&hl=pt_BR';

/**
 * Convite pós-login para usar o AgriGest como app no celular.
 *
 * Android: leva para o app nativo na Play Store.
 * iOS: Safari não deixa instalar PWA por botão (não expõe beforeinstallprompt),
 * então explicamos o passo a passo de "Adicionar à Tela de Início". Se por acaso
 * o navegador oferecer o prompt nativo (Android/Chrome aberto no site), também
 * mostramos um botão "Instalar".
 *
 * @param plataforma 'android' | 'ios'
 * @param onClose    fecha o modal (conta como "visto")
 */
export default function ModalApp({ plataforma, onClose }) {
  const { podeInstalar, instalar } = useInstalarPWA();

  const android = plataforma === 'android';

  return (
    <Modal titulo="Leve o AgriGest no bolso" onClose={onClose} largura={440}>
      <div className="modal-app">
        <div className="modal-app__icone" aria-hidden="true">
          <Icon nome="celular" tamanho={40} />
        </div>

        {android ? (
          <>
            <p className="modal-app__texto">
              Agora você pode usar o AgriGest pelo <strong>aplicativo Android</strong>.
              Baixe direto na Play Store e tenha a fazenda na palma da mão.
            </p>
            <a
              href={PLAY_STORE_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="btn-primary botao-largo modal-app__cta"
              onClick={onClose}
            >
              <Icon nome="seta-externa" tamanho={16} />
              Baixar na Play Store
            </a>
          </>
        ) : (
          <>
            <p className="modal-app__texto">
              Agora você pode instalar o aplicativo do AgriGest e ter acesso ainda
              mais fácil, sem precisar utilizar o navegador de internet.
              {podeInstalar
                ? ' Toque no botão abaixo para instalar.'
                : ' Para ter o aplicativo AgriGest no iOS você precisa:'}
            </p>

            {podeInstalar ? (
              <button
                type="button"
                className="btn-primary botao-largo modal-app__cta"
                onClick={async () => { await instalar(); onClose(); }}
              >
                <Icon nome="adicionar" tamanho={16} />
                Instalar o app
              </button>
            ) : (
              <ol className="modal-app__passos">
                <li>
                  Toque no botão <strong>Compartilhar</strong> do Safari
                  <span className="modal-app__dica"> (o quadrado com a seta para cima, na barra inferior)</span>.
                </li>
                <li>
                  Role e toque em <strong>“Adicionar à Tela de Início”</strong>.
                </li>
                <li>
                  Confirme em <strong>“Adicionar”</strong> no canto superior direito.
                </li>
                <li>
                  Pronto: abra o AgriGest pelo ícone novo na tela do iPhone.
                </li>
              </ol>
            )}
            <p className="modal-app__nota">
              <Icon nome="info" tamanho={14} />
              No iPhone a instalação precisa ser feita pelo Safari.
            </p>
          </>
        )}

        <button type="button" className="modal-app__depois" onClick={onClose}>
          Agora não
        </button>
      </div>
    </Modal>
  );
}
